import React, { Component } from 'react';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import { tapArticlesFetch } from '../../actions/index';
// import cx from '../../styles';
// import style from './style.css';
import { translate } from 'react-i18next';
import Template404 from '../../components/404';
import BaseLayout from '../../components/Layout/BaseLayout';

class Template404Container extends Component {

    constructor(props) {
        super(props);
        this.state = {
            suggestedArticles: [],
            isLoading: false
        };
    }

    componentDidMount() {
        this.setState({isLoading: true});
        this.props.tapArticlesFetch('suggested')
        .then(response => {
            if(response && response.status) this.setState({suggestedArticles: response.response.article});
            this.setState({isLoading: false});
        });
        
    }

    render() {
        const {t, history, match, landingUrl, serverReqCookie} = this.props;
        // const siteUrl = this.props.configReducer.siteUrl;        
        // let lc = [];
        // let rc = [];

        return (
            <BaseLayout 
                history={history} 
                match={match}
                landingUrl={landingUrl}
                serverReqCookie={serverReqCookie}
            >
                <Template404 t={t}
                    suggestedArticles={this.state.suggestedArticles}
                    isLoading={this.state.isLoading} />
            </BaseLayout>
        );
    }
}

//map state
const mapStateToProps = (state) => {
    // console.log(state);
    return state;
};

//map dispatch
const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({
        tapArticlesFetch
    }, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(translate()(Template404Container));
